<template>
  <section class="problem-section" aria-labelledby="problem-title">
    <div class="problem-inner">
      <header class="problem-header">
        <h2 id="problem-title" class="problem-title">Come ti aiutiamo?</h2>
        <p class="problem-subtitle">
Ti aiutiamo a definire il percorso più idoneo per garantire una preparazione atletica sicura e professionale, rispettando necessità 
e budget per avere atleti sempre in forma.</p>
      </header>
      <div class="problem-grid">
        <article class="problem-item">
          <h3 class="problem-item-title">Percorsi individualizzati per migliorare la performance </h3>
          <p class="problem-item-text">
            Impostiamo criteri e progressioni in maniera individualizzata per squadre, gruppi e singoli atleti, in modo tale da massimizzare la performance agonistica
          </p>
        </article>
        <article class="problem-item">
          <h3 class="problem-item-title">Metodo condiviso</h3>
          <p class="problem-item-text">
            Mettiamo a disposizione protocolli e criteri comuni, così le scelte operative diventano più allineate nello staff e l'accesso a piani di allenamento e dati diventa semplice e veloce.
          </p>
        </article>
        <article class="problem-item">
          <h3 class="problem-item-title">Prevenzione strutturata</h3>
          <p class="problem-item-text">
            Inseriamo test periodici e monitoraggio del carico, per rendere la prevenzione sport-specifica continua e non occasionale, riducendo le percentuali di infortuni degli atleti.
          </p>
        </article>
        <article class="problem-item">
          <h3 class="problem-item-title">Più tempo sul campo</h3>
          <p class="problem-item-text">
            Semplifichiamo pianificazione e revisione dei carichi, riducendo il lavoro manuale anche con risorse limitate.          </p>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ProblemSection'
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";

.problem-section {
  background-color: $white;
  color: $black;
}

.problem-inner {
  padding: 56px 24px;
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.problem-header {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.problem-title {
  margin: 0;
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.2;
}

.problem-subtitle {
  margin: 0;
  font-size: 1.05rem;
  line-height: 1.7;
}

.problem-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}

.problem-item {
  border: 1px solid $black;
  border-radius: 25px;
  color: $black;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 304px;
}

.problem-item-title {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  text-align: left;
}

.problem-item-text {
  margin: 0;
  font-size: 1.1rem;
  line-height: 1.6;
  flex: 1;
  display: flex;
  align-items: center;
  text-align: left;
}

@media (min-width: 768px) {
  .problem-inner {
    padding: 64px 40px;
  }
  .problem-item {
    padding: 2rem;
    height: 232px;
  }
}

@media (min-width: 900px) and (orientation: landscape) {
  .problem-inner {
    padding: 80px 120px;
    gap: 40px;
  }

  .problem-title {
    font-size: 2.4rem;
  }

  .problem-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 32px;
  }

  .problem-item {
    padding: 2rem;
    height: 256px;
  }
}

</style>
